// src/actions/exams.js
import api from '../interceptor';
export const GET_EXAMS_BY_ORDER_REQUEST = 'GET_EXAMS_BY_ORDER_REQUEST';
export const GET_EXAMS_BY_ORDER_SUCCESS = 'GET_EXAMS_BY_ORDER_SUCCESS';
export const GET_EXAMS_BY_ORDER_FAILURE = 'GET_EXAMS_BY_ORDER_FAILURE';
export const SET_EXAMS_BY_ORDER = 'SET_EXAMS_BY_ORDER';
export const FETCH_PATIENTS = 'FETCH_PATIENTS';
export const SET_FILTER_RANGE = "SET_FILTER_RANGE";
export const FILTER_ORDERS_REQUEST = "FILTER_ORDERS_REQUEST";
export const FILTER_ORDERS_SUCCESS = "FILTER_ORDERS_SUCCESS";
export const FILTER_ORDERS_FAILURE = "FILTER_ORDERS_FAILURE";
export const SET_LAST_FILTERED_PATIENTS = "SET_LAST_FILTERED_PATIENTS";

export const getExamsByOrder1 = (orderId) => async (dispatch) => {
  dispatch({ type: GET_EXAMS_BY_ORDER_REQUEST });

  try {
    const response = await api.get(`/api/lis/testResults/${orderId}`);
    dispatch({
      type: GET_EXAMS_BY_ORDER_SUCCESS,
      payload: response.data.results
    });
  } catch (error) {
    dispatch({
      type: GET_EXAMS_BY_ORDER_FAILURE,
      payload: error.message
    });
  }
};

// src/actions/exams.js
export const getExamsByOrder = (orderNumber) => async (dispatch) => {
  try {
   
    const response = await api
            .get(`/api/practitioners/testResults/${orderNumber}`)
    const data = await response.data;

     console.log("RESPUESTA TEST RESULTS:", data);

    dispatch({
      type: SET_EXAMS_BY_ORDER,
      payload: { 
        orderNumber, 
        exams: data.results.examenes,
        isOrderSpecial: data.results?.isOrderSpecial || false,
       },
    });
  } catch (error) {
    dispatch({
      type: GET_EXAMS_BY_ORDER_FAILURE,
      payload: error.response?.status || error.message,
    });
    console.error("Error fetching exams:", error);
  }
};

export const filterOrders = (filters) => async dispatch => {

  dispatch({ type: FILTER_ORDERS_REQUEST });

  try {
    const response = await api.post('/api/practitioners/filterOrders',filters);
    console.log("Respuesta del filtro:", response);

    const data = Array.isArray(response.data) ? response.data : []
    dispatch({
      type: FILTER_ORDERS_SUCCESS,
      payload:data
    });

    return data;
  } catch (error) {

      dispatch({
        type: FILTER_ORDERS_FAILURE,
        payload: error.response?.status || error.message,
      });
      return [];
    
  }
}
//conserva la fecha de filtro
export const setFilterRange = (payload) => ({
  type: SET_FILTER_RANGE,
  payload
});

//conserva los ultimos buscados
export const setLastFilteredPatients = (patients) => {
  return {
  type: SET_LAST_FILTERED_PATIENTS,
  payload: patients
  }
}

